import dayjs from 'dayjs';

export interface IDaily5Model {
  appt: Date;
  eta: Date;
  hoursPerDay: {
    day1: number;
    day2: number;
    day3: number;
  };
  pta: Date;
  runningOnTime: string;
  tractorId: number;
}

export class Daily5Model implements IDaily5Model {
  appt: Date;
  errors: any[];
  eta: Date;
  hoursPerDay: {
    day1: number;
    day2: number;
    day3: number;
  };
  pta: Date;
  runningOnTime: string;
  tractorId: number;

  constructor(daily5: IDaily5Model) {
    this.appt = daily5.appt;
    this.eta = daily5.eta;
    this.errors = [];
    this.hoursPerDay = daily5.hoursPerDay || { day1: undefined, day2: undefined, day3: undefined };
    this.pta = daily5.pta;
    this.runningOnTime = daily5.runningOnTime;
    this.tractorId = daily5.tractorId;
  }

  public isValid(): boolean {
    this.errors = [];
    const fieldsNotNull =
      !(this.appt === null || this.appt === undefined) &&
      !(this.eta === null || this.eta === undefined) &&
      !(this.pta === null || this.pta === undefined) &&
      !(this.runningOnTime === null || this.runningOnTime === undefined) &&
      !(this.hoursPerDay === null || this.hoursPerDay === undefined) &&
      !(this.hoursPerDay.day1 === null || this.hoursPerDay.day1 === undefined) &&
      !(this.hoursPerDay.day2 === null || this.hoursPerDay.day2 === undefined) &&
      !(this.hoursPerDay.day3 === null || this.hoursPerDay.day3 === undefined);
    if (fieldsNotNull) {
      if (this.eta < new Date()) {
        this.errors.push({
          severity: 'error',
          detail: 'The driver should not be allowed to pick dates/times in the past',
        });
      }
      if (this.pta <= this.eta) {
        this.errors.push({
          severity: 'error',
          detail: 'PTA should be greater than ETA',
        });
      }
      if (this.hoursPerDay.day1 < 0 || this.hoursPerDay.day2 < 0 || this.hoursPerDay.day3 < 0) {
        this.errors.push({
          severity: 'error',
          detail: 'Days drive hours should be greater than zero',
        });
      }
      if (
        this.hoursPerDay.day1 % 1 > 0 ||
        this.hoursPerDay.day2 % 1 > 0 ||
        this.hoursPerDay.day3 % 1 > 0
      ) {
        this.errors.push({
          severity: 'error',
          detail: 'Days drive hours should not have decimal places',
        });
      }
      if (this.errors.length === 0) {
        return true;
      }
    }
    return false;
  }

  public toJSON() {
    return {
      tractor: this.tractorId,
      tripPlan: this.runningOnTime,
      eta: dayjs(this.eta).format('YYYY-MM-DDTHH:mm:ssZ'),
      pta: dayjs(this.pta).format('YYYY-MM-DDTHH:mm:ssZ'),
      appt: dayjs(this.appt).format('YYYY-MM-DDTHH:mm:ssZ'),
      hoursDay1: this.hoursPerDay.day1,
      hoursDay2: this.hoursPerDay.day2,
      hoursDay3: this.hoursPerDay.day3,
    };
  }
}
